export default "__VITE_ASSET__BpSnrvK0__"